import React from "react";

export function TermInputPair({children,className,required=false,label,annotation,ddClassName=""}) {
    return (
        <dl className={className}>
            <dt className={required ? "required" : ""}>{label}{annotation && <span>{annotation}</span>}</dt>
            <dd className={ddClassName}>{children}</dd>
        </dl>
    );
}